import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'gb-content-full',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet />`,
})
export class ContentFullComponent {}
